import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '../pipes/pipes.module';
import { BackgroundImageComponent } from './background-image.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { UserProfileImageComponent } from './user-profile-image/user-profile-image.component';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        PipesModule
    ],
    declarations: [
        ImagePreviewComponent,
        BackgroundImageComponent,
        UserProfileImageComponent,
    ],
    exports: [
        ImagePreviewComponent,
        BackgroundImageComponent,
        UserProfileImageComponent,
    ]
})
export class ImagesModule {

}
